var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { action, observable, toJS } from 'mobx';
import { publish, subscribe } from 'sdc-publish-subscribe';

var LanguagesStore = (_class = function LanguagesStore() {
  var _this = this;

  _classCallCheck(this, LanguagesStore);

  _initDefineProp(this, 'defaultLanguage', _descriptor, this);

  _initDefineProp(this, 'selectedLanguage', _descriptor2, this);

  _initDefineProp(this, 'languages', _descriptor3, this);

  _initDefineProp(this, 'languagesAvailable', _descriptor4, this);

  _initDefineProp(this, 'setLanguagesAvailable', _descriptor5, this);

  _initDefineProp(this, 'setLanguagesDefined', _descriptor6, this);

  _initDefineProp(this, 'setLanguages', _descriptor7, this);

  _initDefineProp(this, 'setDefaultLanguage', _descriptor8, this);

  this.selectLanguage = function (language) {
    return action(function () {
      _this.selectedLanguage = language;
      publish('selected-language', toJS(language));
    });
  };

  this.labelFrom = function (input, locale) {
    if (!input) return null;
    if (typeof input === 'string') return input;
    if (typeof input === 'number') return input;
    var language = (locale || {}).key || _this.selectedLanguage;
    if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') return input[language] || input[_this.defaultLanguage];
    return '[' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + ': ' + JSON.stringify(input) + ']';
  };

  subscribe('i18n.languages.available', this.setLanguagesAvailable);
  subscribe('i18n.languages.defined', this.setLanguagesDefined);
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'defaultLanguage', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'en';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'selectedLanguage', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'en';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'languages', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'languagesAvailable', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'setLanguagesAvailable', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (languages) {
      if (languages) {
        _this2.languagesAvailable = languages;
      }
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'setLanguagesDefined', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (languages) {
      var position = function position(l) {
        return l.position || 0;
      };
      var byPosition = function byPosition(l1, l2) {
        return position(l1) - position(l2);
      };

      if (languages) {
        _this3.languages = languages;
        var provided = Object.values(languages);
        var sorted = provided.sort(byPosition);
        _this3.languagesAvailable = sorted.map(function (l) {
          return l.key;
        });
        var defaultLanguage = provided.find(function (l) {
          return l.default;
        });
        if (defaultLanguage) {
          console.log('setting default language to marked \'' + defaultLanguage.key + '\'');
          _this3.setDefaultLanguage(defaultLanguage.key);
        } else {
          var firstLanguage = sorted[0] || {};
          console.log('setting default language to first \'' + firstLanguage.key + '\'');
          _this3.setDefaultLanguage(firstLanguage.key);
        }
      }
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'setLanguages', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (languages) {
      _this4.languages = languages;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'setDefaultLanguage', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (language) {
      _this5.defaultLanguage = language;
      publish('default-language', toJS(language));
    };
  }
})), _class);


export var languagesStore = new LanguagesStore();